import * as THREE from 'three';
import Action from '../classes/Action';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import Scenario from '../classes/scenarioElements/Scenario';
import { SaveModificationTypes, CustomEventTypes } from '../globals';
import ProjectSaver from '../classes/ProjectSaver';
import Text3D from '../classes/Text3D';
import ScopeLight from '../classes/Light';
import AudioSource from '../classes/AudioSource';
import ScopeCamera from '../classes/Camera';

export default class SetObjectCustomProperties extends Action
{
	constructor(objects: THREE.Object3D[], setterFuncNames: string[], newValues: any[][], oldValues: any[][], actionName: string)
	{
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, setterFuncNames, newValues, isDefaultState],
			[objects, setterFuncNames, oldValues, isDefaultState],
			actionName,
			[objects, setterFuncNames, newValues, oldValues]);
	}

	do(objects: THREE.Object3D[], setterFuncNames: string[], values: any[], isDefaultState: boolean) : void
	{
		for (let i = 0; i < setterFuncNames.length; i++)
		{
			const setterFuncName = setterFuncNames[i];
			if (isDefaultState) DefaultSceneManager.getInstance().syncCustomObjectProperty(objects, setterFuncName, values[i]);

			for (let j = 0; j < objects.length; j++)
			{
				const object = objects[j];
				object[setterFuncName](values[i][j]);

				if (object instanceof Text3D) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Text3D);
				else if (object instanceof ScopeLight) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Light);
				else if (object instanceof ScopeCamera) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Camera);
				else if (object instanceof AudioSource) ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Audio);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateAudioComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateCameraComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateLightComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.update3DTextComponent));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updateTrackerComponent));
	}

	verify(objects: THREE.Object3D[], setterFuncNames: string[], newValues: any[], oldValues: any[]) : boolean
	{
		if (objects.length === 0 || setterFuncNames.length !== newValues.length || setterFuncNames.length !== oldValues.length) return false;

		for (let i = 0; i < setterFuncNames.length; i++)
		{
			for (let j = 0; j < objects.length; j++)
			{
				if (newValues[i][j] !== oldValues[i][j])
				{
					return true;
				}
			}
		}

		return false;
	}
}
